import React from "react";
import { Row, Typography, Checkbox } from "antd";
import useGlobal from "../store";
import { POSSIBLE_EXCLUDED_SELLERS, POSSIBLE_EXCLUDED_PLATFORMS } from "../globals";

const SellerBuyerOptions = () => {
  const [globalState, globalActions] = useGlobal();

  const {
    showSellerInformation,
    showBuyerInformation,
    excludeNoFeedback,
    excludeLowFeedback,
    excludeNoSellerFeedback,
    excludeBuyItNow,
    excludeAuctions,
    excludeSaleWithMakeOffer,
    excludeSellersFromChartResults,
    excludePlatformsFromChartResults,
  } = globalState;

  return (
    <div style={{ padding: 12, borderBottom: "1px solid #dadada" }}>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text strong>Seller</Typography.Text>
          <Row style={{ padding: ".25rem" }}>
            {POSSIBLE_EXCLUDED_SELLERS.map((seller, index) => {
              const checked = excludeSellersFromChartResults.includes(seller);
              return (
                <Checkbox
                  key={index}
                  style={{ marginLeft: 8 }}
                  checked={checked}
                  onChange={() =>
                    globalActions.setExcludeSellersFromChartResults(globalState.excludeSellersFromChartResults, seller)
                  }
                >
                  Exclude {seller}
                </Checkbox>
              );
            })}
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={showSellerInformation}
              onChange={() => globalActions.setShowSellerInformation(!showSellerInformation)}
            >
              Show Seller Name
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={excludeNoSellerFeedback}
              onChange={() => globalActions.setExcludeNoSellerFeedback(!excludeNoSellerFeedback)}
            >
              Exclude 0 Seller Feedback
            </Checkbox>
          </Row>
        </div>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text strong>Buyer</Typography.Text>
          <Row style={{ padding: ".25rem" }}>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={showBuyerInformation}
              onChange={() => globalActions.setShowBuyerInformation(!showBuyerInformation)}
            >
              Show Buyer Feedback Rating
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={excludeNoFeedback}
              onChange={() => globalActions.setExcludeNoFeedback(!excludeNoFeedback)}
            >
              Exclude 0 Feedback
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={excludeLowFeedback}
              onChange={() => globalActions.setExcludeLowFeedback(!excludeLowFeedback)}
            >
              Exclude &lt;10 Feedback Rating
            </Checkbox>
          </Row>
        </div>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text strong>Platform</Typography.Text>
          <Row style={{ padding: ".25rem" }}>
            {POSSIBLE_EXCLUDED_PLATFORMS.map((platform, index) => {
              return (
                <Checkbox
                  key={index}
                  style={{ width: "100%", marginLeft: 8 }}
                  checked={excludePlatformsFromChartResults.includes(platform.key)}
                  onChange={() =>
                    globalActions.setExcludePlatformsFromChartResults(excludePlatformsFromChartResults, platform.key)
                  }
                >
                  Exclude {platform.title}
                </Checkbox>
              );
            })}
            <Checkbox
              style={{ width: "100%", marginLeft: 8 }}
              checked={excludeSellersFromChartResults.includes("Goldin Auctions")}
              onChange={() =>
                globalActions.setExcludeSellersFromChartResults(
                  globalState.excludeSellersFromChartResults,
                  "Goldin Auctions",
                )
              }
            >
              Exclude Goldin Auctions
            </Checkbox>
          </Row>
        </div>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text strong>Sale Type</Typography.Text>
          <Row style={{ padding: ".25rem" }}>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={excludeBuyItNow}
              onChange={() => globalActions.setExcludeBuyItNow(!excludeBuyItNow)}
            >
              Exclude Buy It Now
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={excludeAuctions}
              onChange={() => globalActions.setExcludeAuctions(!excludeAuctions)}
            >
              Exclude Auctions
            </Checkbox>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={excludeSaleWithMakeOffer}
              onChange={() => globalActions.setExcludeSaleWithMakeOffer(!excludeSaleWithMakeOffer)}
            >
              Exclude Accepted Best Offers
            </Checkbox>
          </Row>
        </div>
      </div>
    </div>
  );
};

export { SellerBuyerOptions };
